import React, {FC} from 'react';
import {Typography} from 'onboarding-components';

import {TEXT_HIGHLIGHT_THEME, TextHighlightReact} from 'common/components/text-highlight';

import style from './implement-method-button.module.styl';
import textHighlightStyleOverride from './textHighlight.inline.styl';

interface ImplementMethodButtonProps {
  title: string;
  url: string;
  imgSrc: string;
  highlight?: string;
  onClick?: () => void;
}

export const ImplementMethodButton: FC<ImplementMethodButtonProps> = (props) => {
  return (
    <a className={style.implementMethod} href={props.url} target='_blank' onClick={props.onClick}>
      <div className={style.implementMethodIcon}>
        <img src={props.imgSrc} />
      </div>
      <div className={style.implementMethodTextContainer}>
        <Typography variant='captionXs' weight='bold' className={style.implementMethodText}>
          {props.title}
        </Typography>
        {props.highlight && (
          <TextHighlightReact
            style-override={textHighlightStyleOverride}
            size='small'
            theme={TEXT_HIGHLIGHT_THEME.SUCCESS}
            text={props.highlight}
          />
        )}
      </div>
    </a>
  );
};
